import { defineCartButtonComponent } from '@nx-paeonia/feature-components';

defineCartButtonComponent();
